// extracted by mini-css-extract-plugin
module.exports = {"content":"TokenPortfolio_content__2owyw","sending":"TokenPortfolio_sending__2wU1l"};